import LegacyButton from "../../../components/Atomos/Buttons/LegacyButton";
import chevronRightButton from "../../../assets/Fonts/chevron-right-button.svg";
import IconLocation from "../../../assets/images&icons/Icon-Location.png";
import { useParams } from "react-router-dom";
import { useEventLoader } from "../../../hooks/Events/useEventLoader";

const formatUrl = (url: string) => {
  if (url && !url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};

const getCurrencySymbol = (currencyCode: string): string => {
  const currencyMap: { [key: string]: string } = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥",
    CAD: "C$",
    AUD: "A$",
    CHF: "CHF",
    CNY: "¥",
    INR: "₹",
    MXN: "$",
    BRL: "R$",
    ZAR: "R",
    SEK: "kr",
    NOK: "kr",
    DKK: "kr",
    PLN: "zł",
    RUB: "₽",
    TRY: "₺",
    KRW: "₩",
    SGD: "S$",
    HKD: "HK$",
    NZD: "NZ$",
    THB: "฿",
    MYR: "RM",
    PHP: "₱",
    IDR: "Rp",
    VND: "₫",
  };
  return currencyMap[currencyCode] || currencyCode;
};

export default function MemberAccomodationsTab() {
  const { id } = useParams<{ id: string }>();
  const event = useEventLoader(id);
  if (!event) {
    return <div>Event not found</div>;
  }
  if (!event.accomodation?.length) {
    return <div>No accomodations found</div>;
  }
  return (
    <div>
      {event.accomodation?.map((accomodation, index) => (
        <div
          key={accomodation.name}
          className="flex flex-col lg:flex-row gap-4 mb-4"
        >
          {index % 2 !== 0 && (
            <img
              src={accomodation.image}
              alt="accomodation"
              className="w-full lg:w-1/4 h-auto object-cover hidden lg:block"
            />
          )}
          <img
            src={accomodation.image}
            alt="accomodation"
            className="w-full lg:w-1/4 h-auto object-cover block lg:hidden"
          />
          <div className="bg-gray-100 w-full lg:w-3/4">
            <p className="text-gray-font text-[22px] font-normal leading-4 md:leading-5 font-roboto text-left border-b border-primary w-fit pl-4 pt-4 pb-2">
              Hotel
            </p>
            <div className="flex flex-row lg:flex-col gap-4 p-4">
              <div key={accomodation.name}>
                <div className="flex flex-col lg:flex-row gap-2 items-start justify-between">
                  <div className="flex flex-row gap-2 items-start">
                    <img
                      src={IconLocation}
                      alt="location"
                      className="w-10 h-10 mt-1"
                    />

                    <div className="flex flex-col gap-1 items-start">
                      <p className="text-[#0070CD] font-decimal text-base md:text-lg lg:text-xl font-[500] text-left cursor-pointer" onClick={() => {
                        window.open(formatUrl(accomodation.url), "_blank");
                      }}>
                        {accomodation.name}
                      </p>

                      <p className="text-gray-font text-base md:text-lg lg:text-xl font-[400] font-decimal">
                        {accomodation.address}
                      </p>
                      {accomodation.reservationUrl && <LegacyButton
                        text="BOOK NOW"
                        onClick={() => {
                          const url = accomodation.reservationUrl
                          window.open(formatUrl(url!), "_blank");
                        }}
                        color="primary"
                        content="textIcon"
                        className="w-full md:w-[200px] !hidden md:!block lg:!hidden"
                        icon={
                          <img
                            src={chevronRightButton}
                            alt="chevron"
                            className="w-3 h-3"
                          />
                        }
                      />}
                    </div>
                  </div>
                  {accomodation.reservationUrl && <LegacyButton
                    text="BOOK NOW"
                    onClick={() => {
                      const url = accomodation.reservationUrl
                      window.open(formatUrl(url!), "_blank");
                    }}
                    color="primary"
                    content="textIcon"
                    className="w-full md:w-[200px] md:!hidden lg:!block !text-sm "
                    icon={
                      <img
                        src={chevronRightButton}
                        alt="chevron"
                        className="w-3 h-3"
                      />
                    }
                  />}
                </div>
                {(accomodation as any).sectionTitle && (
                  <p className="text-gray-font text-base md:text-lg font-[600] font-roboto text-left uppercase pt-2 pl-0">
                    {(accomodation as any).sectionTitle}
                  </p>
                )}
                <p className="text-gray-font text-sm lg:text-base font-[350] font-roboto text-left pt-4 whitespace-pre-line">
                  {accomodation.description}
                </p>
                {(() => {
                  const roomType = (accomodation as any).roomType || "";
                  const roomRate = (accomodation as any).roomRate || "";
                  const currency = (accomodation as any).currency || "";

                  if (!roomType && !roomRate) {
                    return null;
                  }

                  const currencySymbol = currency
                    ? getCurrencySymbol(currency)
                    : "";
                  const formattedRate = roomRate
                    ? `${currencySymbol}${roomRate}`
                    : "";

                  return (
                    <div className="pt-4">
                      <div className="flex gap-4">
                        <div className="w-32">
                          <div className="text-gray-font text-sm lg:text-base font-bold font-roboto text-left">
                            Room Type
                          </div>
                          <div className="text-gray-font text-sm lg:text-base font-normal font-roboto text-left">
                            {roomType || "-"}
                          </div>
                        </div>
                        <div>
                          <div className="text-gray-font text-sm lg:text-base font-bold font-roboto text-left">
                            Room Rate
                          </div>
                          <div className="text-gray-font text-sm lg:text-base font-normal font-roboto text-left">
                            {formattedRate || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
          {index % 2 === 0 && (
            <img
              src={accomodation.image}
              alt="accomodation"
              className="w-full lg:w-1/4 h-auto object-cover hidden lg:block"
            />
          )}
        </div>
      ))}
    </div>
  );
}
